import { z } from 'zod';

export const exactPattern = (pattern: RegExp) => z.string().refine(value => pattern.exec(value)?.[0] === value);
export const requestIDSchema = exactPattern(/^[A-Za-z0-9_-]{1,128}$/);
export const counterSchema = exactPattern(/^(?:0|[1-9][0-9]{0,18})$/).refine(s => s.length < 19 || s <= '9223372036854775807');
export const timestampSchema = exactPattern(/^[1-9][0-9]{0,11}$/).refine(s => s.length < 12 || s <= '253402300799');
export const opaque32Schema = exactPattern(/^[A-Za-z0-9_-]{42}[AEIMQUYcgkosw048]$/);
const edgeSpace = /^[ \u0085\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]/u;
export const profileNameSchema = z.string().refine(s => {
  const points = [...s];
  return points.length >= 1 && points.length <= 80 && new TextEncoder().encode(s).length <= 320 &&
    !/[\u0000-\u001f\u007f-\u009f\u2028\u2029\ud800-\udfff]/u.test(s) && !edgeSpace.test(points[0]!) && !edgeSpace.test(points.at(-1)!);
});

export async function sha256Hex(bytes: Uint8Array): Promise<string> {
  return [...new Uint8Array(await crypto.subtle.digest('SHA-256', bytes.slice().buffer))].map(b => b.toString(16).padStart(2, '0')).join('');
}
